<template>
  <div class="block">
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="data"
      dateField="Date"
      numberField="PONumber"
    />

    <template v-if="data.VendorID">
      <kst-output field="VendorID" :data="data" :catalog="Catalog">
        <template #left>
          <kst-output addons floating-label
            field="VendorAlias" :data="data" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="Vendor" :data="data" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>
    <template v-else>
      <kst-output control-off field="VendorID" :data="data" :catalog="Catalog">
        <kst-output addons expanded floating-label
          field="Vendor" :data="data" :catalog="Catalog"
        />
      </kst-output>
    </template>

    <kst-output field="VendorAddress" :data="data" :catalog="Catalog"/>
    <kst-output field="Comment" :data="data" :catalog="Catalog"/>
    <kst-output field="Status" :data="data" :catalog="Catalog"/>
    <kst-created :data="data"/>
    <kst-last-updated :data="data"/>
    <kst-output field="WarehouseID" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../PurCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>